import { Box, IconButton, Tooltip } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { REPORT_JOB_TYPES } from '@vy/types';
import { VyTableToolbar } from '../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import {
  VyTableFilter,
  type FilterField,
  type FilterLineType,
} from '../../../../components/new-design/vyTableFilter';
import { useTriggerReportJob } from '../../../../hooks/requests/use-trigger-report-job';
import { runMutation } from '../../../../utils/vy-mutation';
import {
  reportFilterButtonWrapperSx,
  reportIconButtonSx,
  reportSearchInputSx,
} from '../../reports-components/report-toolbar-styles';

type FailedInvoiceDeliveriesReportToolbarProps = {
  onSearchChange: (value: string) => void;
  filterFields: FilterField[];
  filters: FilterLineType[];
  onFiltersChange: (filters: FilterLineType[]) => void;
  onExport: () => void;
};

export const FailedInvoiceDeliveriesReportToolbar: React.FC<FailedInvoiceDeliveriesReportToolbarProps> = ({
  onSearchChange,
  filterFields,
  filters,
  onFiltersChange,
  onExport,
}) => {
  const triggerReportJobMutation = useTriggerReportJob();

  const handleTriggerReport = async () => {
    await runMutation(
      triggerReportJobMutation,
      { reportJobType: REPORT_JOB_TYPES.FailedInvoiceDeliveries },
      {
        pending: 'Refreshing report...',
        success: 'Report refreshed',
        error: 'Failed to refresh report',
      },
    );
  };

  return (
    <Box
      sx={{
        px: 2,
        pb: 2,
        display: "flex",
        alignItems: "flex-end",
        flexWrap: "wrap",
        gap: 2
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: '1 1 200px',
          maxWidth: 300,
          minWidth: 160
        }}>
        <VyTableToolbar.SearchInput
          showLabel={false}
          onChange={(event) => onSearchChange(event.target.value)}
          defaultValue=""
          placeholder="Search"
          sx={reportSearchInputSx}
        />
      </Box>
      <Box sx={reportFilterButtonWrapperSx}>
        <VyTableFilter
          fields={filterFields}
          defaultFilters={filters}
          onFiltersChange={onFiltersChange}
        />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 16
        }} />
      <Tooltip title="Refresh report">
        <span>
          <IconButton
            aria-label="Refresh report"
            onClick={handleTriggerReport}
            disabled={triggerReportJobMutation.isLoading}
            sx={reportIconButtonSx}
          >
            <VyIcon icon="Refresh" style={{ transform: 'scale(0.65)' }} />
          </IconButton>
        </span>
      </Tooltip>
      <IconButton onClick={onExport} sx={reportIconButtonSx}>
        <VyIcon icon="Download" style={{ transform: 'scale(0.65)' }} />
      </IconButton>
    </Box>
  );
};
